import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterSelect } from '@/shared/ui';
import { type AttachmentType } from '@/entities/consignments';

import { getAttachmentTypeLabelOptions } from '../model/types';

interface AttachmentTypeSelectProps {
  value: AttachmentType | null;
  onChange: (value: AttachmentType) => void;
  disabled?: boolean;
}

export function AttachmentTypeSelect({ value, onChange, disabled }: AttachmentTypeSelectProps) {
  const { t } = useTranslation();
  const options = useMemo(() => getAttachmentTypeLabelOptions(t), [t]);

  return (
    <FilterSelect
      label={t('onlinesrf.attachment.type.label')}
      value={value || undefined}
      onChange={onChange}
      options={options}
      placeholder={t('onlinesrf.attachment.type.placeholder')}
      width="full"
      disabled={disabled}
    />
  );
}
